<template>
  <div>
    All the constellations considered are <em>homogeneous</em>. This
    means that all the orbits in the constellation are circular with the same
    semi-major axis and inclination. The same number of spacecrafts is evenly
    distributed on each orbital plane. Four types of constellation are available:
    <ul>
      <li>Walker-Delta</li>
      <li>Walker-Star</li>
      <li>Global Streets of Coverage</li>
      <li>Custom</li>
    </ul>
    <br />
    <br/>

    <h4>
    <b>Walker-Delta</b> and <b>Walker-Star</b>
    </h4>
    These are homogeneous
    phased constellations. The ascending nodes of the planes of these
    constellations are evenly distributed along
    <katex-element expression="2\pi" /> and
    <katex-element expression="\pi" /> respectively. Typically this kind of
    constellations are defined by the 4 parameters [i, t, p, f].
    <br />
    <br />
    <ul>
      <li><b>i</b>: inclination of the orbital planes;</li>
      <li>
        <b>t</b>: total number of spacecrafts. 
        <b>The number of spacecrafts per plane</b> is used instead;
      </li>
      <li><b>p</b>: number of orbital planes;</li>
      <li>
        <b>f</b>: inter-plane phasing coefficient. This value defines the
        angular separation between two spacecrafts on two consecutive planes.
        The value of this difference is given by
        <katex-element expression="2\pi f \text{/} t" />. Since
        <katex-element expression="f" /> is supposed to be an integer value, it
        can be at most equal to <katex-element expression="p-1" />.
      </li>
    </ul>
    <br />
    <v-img
      contain
      :src="require('../../../assets/images/tooltip-walker-constellations.png')"
    />
    <br />
    <br />

    <h4>
      <b>Global Streets of Coverage</b> (SOC)
    </h4>
    <p>
      The SOC constellations are a class of
      asymmetrical constellations, where the planes can be distributed either
      along <katex-element expression="2\pi" /> or
      <katex-element expression="\pi" />. The latter is implemented,
      for it generally represents constellations with less orbital planes.
    </p>
    <p>
      These SOC constellations have the characteristic of providing continuous coverage by one or
      more satellites over the entire globe, based on the Street-of-Coverage
      concept, illustrated in the figure below for the case of a single coverage (j=1). It consists on automatically computing the RAAN phasing and the inter-plane phasing angles
      in a way that the fields of regard (FORs) of the spacecrafts on adjacent planes complement each other with minimum overlap.
      This is particularly interesting when looking for producing a global coverage constellation with the minimum number of satellites.

    </p>
    
    <v-img
      contain
      :src="require('../../../assets/images/streets-of-coverage.png')"
      aspect-ratio="0.9"
    />
    <br />

    <p>
      To define a SOC constellation, the following parameters are
      required:

      <ul>
      <li><b>Payload</b>;</li>
      <li>
        <b>j-fold coverage level</b>: minimum number of satellites to be seen by any
        point on the Earth at any given moment;
      </li>
      <li><b>Inclination</b>;</li>
      <li><b>Number of planes</b>;</li>
      <li><b>Number of spacecrafts per plane</b>;</li>
      <li><b>Altitude</b>.</li>
    </ul>
    </p>
    <p>
      A minimum altitude required for the coverage is computed when the other parameters are set.
      The user can then use this value as the constellation altitude, or rather set their own altitude.
    </p>

    <br/>
    <h4>
      <b>Custom</b> 
    </h4>
    <p>
      The Custom constellation definition, on the other hand, allows the
      user to choose different distributions of the ascending nodes and to
      specify the inter-plane phasing angle.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometryConstellationType'
}
</script>
